module.exports = __webpack_public_path__ + "img/Gummies-4ct.837b0f93.jpg";